const fileToBase64 = (file: File): Promise<ArrayBuffer | string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let encoded = reader?.result?.toString().replace(/^data:(.*,)?/, '') || '';
      const padding = encoded?.length % 4;
      if (padding > 0) {
        encoded += '='.repeat(4 - padding);
      }
      resolve(encoded);
    };
    reader.onerror = (error) => reject(error);
  });

export default fileToBase64;
